import { mapFilterUndefined } from "@glideapps/ts-necessities";
import type { AppUserData } from "../common/components/datastore/data-row-store";
import { isRowOwnedByUser } from "../common/components/datastore/is-row-owned";
import type { Row } from "../common/computation-model/data";
import { getRowColumn, isArrayValue, isLoadingValue } from "../common/computation-model/data";
import type { TableGlideType } from "../common/description";

export function isNewRowOwnedByUser(
    row: Row,
    appUserData: AppUserData | undefined,
    table: TableGlideType | undefined
): boolean {
    return isRowOwnedByUser(appUserData, table, columnName => {
        const v = getRowColumn(row, columnName);
        if (typeof v === "string") {
            return v;
        }
        if (isLoadingValue(v)) return undefined;
        if (isArrayValue(v)) {
            return mapFilterUndefined(v, c => {
                if (typeof c !== "string") return undefined;
                return c;
            });
        }
        return undefined;
    });
}
